<template>
    <div style="height: 300px; position: relative">
        <template v-if="loading">
            <div class="fill-height d-flex align-center justify-center">
                <app-centre-loader label="Loading Team Activity"></app-centre-loader>
            </div>
        </template>
        <template v-else-if="stats.length">
            <div style="position: relative">
                <div
                        class="text-center text-h6 font-weight-thin"
                        style="position: absolute; left: 0; top: 0; width: 100%"
                >
                    Team Activity Today
                </div>
                <apex-chart height="300" type="line" :options="chartOptions"
                            :series="chartData.series"></apex-chart>
            </div>
        </template>
        <template v-else>
            <div class="fill-height d-flex align-center justify-center text-overline grey--text text--darken-2">
                No Activity For Today
            </div>

        </template>

    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import {durationDisplay, hourDisplayWithoutUnit, objectifyArr} from "@/core/codeFunctions";
import AppIcon from "@/components/Shared/AppIcon";
import {mapActions} from "vuex";
import AppCentreLoader from "@/components/Shared/AppCentreLoader";
import {format, subHours} from "date-fns";
export default {
    components: {
        AppCentreLoader,
        AppIcon,
        apexChart: VueApexCharts,
    },
    props: {
        propName: {
            type: Number,
            default: 0
        },
    },
    data() {
        return {
            loading: true,
            stats: [],
            gradient: ["var(--v-primary-lighten1)", "var(--v-primary-darken2)"],
            refreshInterval: null,
            hourDisplayWithoutUnit,
            employeeCounts: {},
        }
    },
    mounted() {
        this.loadProductivity();
        this.refreshInterval = setInterval(() => {
            this.loadProductivity()
        }, 60000)
    },
    beforeDestroy() {
        clearInterval(this.refreshInterval)
    },
    methods: {
        ...mapActions(['gotoAppStats']),
        async loadProductivity() {
            try {
                const {stats, employeeCounts} = await this.$newReq('GET', 'dashboard/stats/timeActivityPerTeam')
                this.stats = stats;
                this.employeeCounts = objectifyArr(employeeCounts, "teamName")
                this.loading = false
            } catch (e) {
                console.log(e)
            }
        }
    },
    computed: {
        labels() {return this.stats.map(stat => stat.key)},
        series() {
            const total = this.stats.reduce((val, item) => {
                return val + item.value
            }, 0)
            return this.stats.map(stat => stat.value/total * 100)
        },

        chartData() {
            const teams = this.stats.reduce((list, item) => list.includes(item.teamName) ? list : list.concat(item.teamName), [])
            teams.sort()

            if (!this.stats.length)
                return null

            const startInterval = this.stats[0].bs
            const endInterval = this.stats[this.stats.length - 1].bs

            let seriesData = [];

            for (const team of teams) {
                const teamData = this.stats.filter(obj => obj.teamName === team)
                const employeeCount = this.employeeCounts[team] ? this.employeeCounts[team].employeesCount : 1
                const viewData = []
                for (let k = startInterval; k <= endInterval; k = k + 900) {
                    const ref = teamData.find(stat => stat.bs === k)
                    viewData.push(ref ? (ref.tt / employeeCount) : 0)
                }
                seriesData.push({
                    name: team,
                    data: viewData
                })
            }

            const labels = []

            for (let k = startInterval; k <= endInterval; k = k + 900) {
                labels.push(format(new Date(k * 1000), "HH:mm"))
            }

            return {
                labels: labels,
                series: seriesData
            }
        },

        chartOptions() {
            // Get A List Of Teams

            const chartOptions = {
                chart: {
                    height: 350,
                    type: 'line',
                    zoom: {enabled: false},
                    toolbar: {
                        tools: {
                            download: false,
                        },
                    },
                    animations: {
                        enabled: true,
                        easing: 'easeinout',
                        speed: 800,
                        animateGradually: {
                            enabled: false,
                        },
                    },
                },
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    curve: 'smooth',
                    width: 2
                },
                grid: {
                    show: true,
                    borderColor: 'var(--v-primary-base)',
                    strokeDashArray: 0,
                    position: 'back',
                    yaxis: {
                        lines: {
                            show: false
                        }
                    },
                },
                xaxis: {
                    categories: this.chartData.labels,
                    labels: {
                        rotate: -60,
                        rotateAlways: true,
                        style: {
                            colors: this.chartData.labels.map(() => '#fff'),
                        },
                    },
                    axisBorder: {
                        show: true,
                        color: 'var(--v-primary-base)',
                        height: 1,
                    },
                },
                tooltip: {
                    enabled: false,
                    theme: 'dark',
                    y: {
                        formatter: function (val) {
                            return durationDisplay(val)
                        },
                        title: {
                            formatter: (seriesName) => seriesName,
                        },
                    },
                },
                yaxis: {
                    show: true,
                    title: {
                        text: 'Activity'
                    },
                    labels: {
                        show: false,
                    },
                },
                legend: {
                    labels: {
                        colors: ['#fff']
                    },
                },
            }

            return chartOptions
        },
    }
}
</script>

<style scoped>

.txt:hover {
    text-decoration: underline;
    color: #fff !important;
    cursor: pointer;
}

</style>